import { render, staticRenderFns } from "./votePackTable.vue?vue&type=template&id=a24737d4&scoped=true&"
import script from "./votePackTable.vue?vue&type=script&lang=ts&"
export * from "./votePackTable.vue?vue&type=script&lang=ts&"
import style0 from "./votePackTable.vue?vue&type=style&index=0&id=a24737d4&lang=scss&scoped=true&"
import style1 from "./votePackTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24737d4",
  null
  
)

export default component.exports